import React, {
  useEffect
  // useState
} from 'react';

// import { SvgComponent } from '@quikr/ui';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// import CallflowIcon from '../../assets/call-flow-sprite.svg';
import Container from '../FlexBox/Container';

// const CrossDiv = styled.div`
//   svg {
//     width: 20px;
//     height: 20px;
//     margin-left: 14px;
//   }
// `;

const SwitchToQuikrAI = styled.div`
  background: #fff2d1;
  padding: 10px;
  a {
    color: ${({ theme }) => theme.colors.Primary};
    text-decoration: underline;
  }
`;

const Link = styled.button`
  background: none;
  color: ${({ theme }) => theme.colors.Primary};
  text-decoration: underline;
`;

const HeaderSwitchBanner = ({ category, city = {}, pageType, subCategory, useGa, ...props }) => {
  // const [display, setDisplay] = useState(true);
  const { TriggerGaEvent } = useGa();

  const fireVAPGa = eventLabel => {
    const gaEventobj = {
      category: `${pageType}_${category}`,
      label: `switch_banner_${eventLabel}`,
      action: `${subCategory}_${city.name}`
    };

    TriggerGaEvent(gaEventobj);
  };

  // const handleCloseClick = () => {
  //   setDisplay(!display);
  //   fireVAPGa('closed');
  // };

  useEffect(() => {
    fireVAPGa('shown');
  }, []);

  const handleLinkClick = e => {
    e.preventDefault();
    fireVAPGa('clicked');
    setTimeout(() => {
      window.location.href = 'https://www.quikr.com/quikrplus/agent';
    }, 300);
  };

  return (
    <>
      {/* {display && ( */}
      <SwitchToQuikrAI>
        <Container className="pR taC">
          <Link className="bt1 boN p0 m0" onClick={handleLinkClick} type="button">
            Switch to Quikr AI
          </Link>
          {/* <div className="dF pA r0 t0">
              <CrossDiv className="cP" onClick={handleCloseClick}>
                <SvgComponent svgSprite={CallflowIcon} id="ic_close" />
              </CrossDiv>
            </div> */}
        </Container>
      </SwitchToQuikrAI>
      {/* )} */}
    </>
  );
};

HeaderSwitchBanner.propTypes = {
  category: PropTypes.string,
  city: PropTypes.object,
  pageType: PropTypes.string,
  subCategory: PropTypes.string,
  useGa: PropTypes.func
};

export default HeaderSwitchBanner;
